import axios, { AxiosPromise } from "axios";

const uri = '/system/log';

export const creatMenuAccessLog = (data: FormData): AxiosPromise => {
    return axios.post(uri + '/menu/access', data);
};